import Form from "./Form";
import useAboutYourCaravan from "./hooks/useAboutYourCaravan";

export const AboutYourCaravan: React.FC = () => {
  const { ...props } = useAboutYourCaravan();

  return <Form {...props} />;
};
export default AboutYourCaravan;
